import { useQuery } from '@tanstack/react-query';
import { getAssignableConsentResponseData, getAssignableConsentTemplates } from './create_consent_modal_data';
export const useDocumentTemplates = ({ apiClient, siteId }) => {
    const fetchTemplates = async () => {
        if (!apiClient || !siteId) {
            return [];
        }
        const response = await apiClient.get('/v2/routes/econsent/assignable-consents', {
            params: { c_site: siteId },
        });
        // The PTS signal lives on the signed document (chosen via the signature-type radio), not
        // the template, so this hook returns every assignable template regardless of signature
        // type. The eSign list is narrowed downstream instead: a template with no digital fields
        // has nowhere to capture a signature, so the modal filters those out of eSign only — see
        // isPtsOnlyDocumentTemplate in create_consent_modal_data.ts. Only Studio PDF templates are
        // assignable from this modal; classic/legacy templates have no published Studio template
        // and cannot be driven here.
        return getAssignableConsentTemplates(getAssignableConsentResponseData(response?.data))
            .filter((template) => !!template.ec__published_studio_template)
            .sort((a, b) => {
            const titleComparison = (a.ec__title || '').localeCompare(b.ec__title || '');
            if (titleComparison) {
                return titleComparison;
            }
            return new Date(b.ec__published || 0).getTime() - new Date(a.ec__published || 0).getTime();
        });
    };
    return useQuery({
        queryKey: ['assignable-consents', siteId],
        queryFn: fetchTemplates,
        enabled: !!apiClient && !!siteId,
        refetchOnWindowFocus: false,
    });
};
